export const initialState = {
	layout: 'material',
	theme: 'light',
	main: '#f75f52',
	background: '#ffffff',
	text: '#000000',
	tabs: ['card', 'phone', 'wallet'],
  tabIndex: {
	  id: 0,
    name: 'card',
  },
	mainPreset: '#f75f52',
	backgroundPreset: '#ffffff',
	textPreset: '#000000',
	userTheme: 'light',
	presetIndex: 0,
	isPresetChanged: false,
};



// WEBPACK FOOTER //
// ./src/store/initialState.js